/**
 * Returns true if the two given account references are equal.
 */
export function isAccountReferenceEqual(a, b) {
    var _a, _b;
    if (((_a = a === null || a === void 0 ? void 0 : a.consumerIdentity) === null || _a === void 0 ? void 0 : _a.identityValue) !== ((_b = b === null || b === void 0 ? void 0 : b.consumerIdentity) === null || _b === void 0 ? void 0 : _b.identityValue)) {
        return false;
    }
    if ((a === null || a === void 0 ? void 0 : a.srcDigitalCardId) !== (b === null || b === void 0 ? void 0 : b.srcDigitalCardId)) {
        return false;
    }
    return true;
}
